import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Alert,
  Button,
  Form,
  InputGroup,
  Modal,
  Spinner,
} from "react-bootstrap";
import useAuth from "../../hooks/useAuth";
import Loader from "../Loader";
import GoogleIcon from "../../assets/img/new/googleIcon.svg";
import { Eye, EyeOff } from "react-feather";
import TwoFactorAuth from "./TwoFactorAuth";
import { useNavigate } from "react-router-dom";
import NotyfContext from "../../contexts/NotyfContext";
function SignIn() {
  const notyf = React.useContext(NotyfContext);
  const { signIn, signInWithGoogle, resetPassword, dispatchTwoFactorAuth } =
    useAuth();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordResetModal, setShowPasswordResetModal] = useState(false);
  const [twoFAModal, setTwoFAModal] = useState(false);
  const [resetPasswordLinkSent, setResetPasswordLinkSent] = useState(false);
  if (showLoader) {
    <Loader />;
  }

  return (
    <>
      <Formik
        initialValues={{
          email: "",
          password: "",
          submit: false,
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .email("Must be a valid email")
            .max(255)
            .required("Email is required"),
          password: Yup.string().max(255).required("Password is required"),
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            setShowLoader(true);
            const resp = await signIn(
              values.email,
              values.password,
              setStatus,
              setErrors,
              setSubmitting
            );
            if (resp?.enable_2fa && !twoFAModal) {
              setTwoFAModal(true);
            }

            setShowLoader(false);
            // navigate("/dashboard");
          } catch (error) {
            const message = error.message || "Something went wrong";
            setShowLoader(false);
            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          setErrors,
          setStatus,
          setSubmitting,
        }) => (
          <>
            <Form onSubmit={handleSubmit}>
              {errors.submit && (
                <Alert className="my-3" variant="danger">
                  <div className="alert-message">{errors.submit}</div>
                </Alert>
              )}

              <Form.Group className="mb-3">
                <Form.Label className="text-light-gray">Email</Form.Label>
                <Form.Control
                  size="lg"
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={values.email}
                  isInvalid={Boolean(touched.email && errors.email)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {!!touched.email && (
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                )}
              </Form.Group>

              <Form.Group>
                <Form.Label>Password</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    size="lg"
                    type={`${!showPassword ? "password" : "text"}`}
                    name="password"
                    placeholder="Enter your password"
                    value={values.password}
                    isInvalid={Boolean(touched.password && errors.password)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                  <span
                    className="position-absolute top-50 end-0 translate-middle-y text-dark-blue"
                    style={{ cursor: "pointer", marginRight: "10px" }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff /> : <Eye />}
                  </span>
                </div>
              </Form.Group>

              <Form.Group
                className="mb-4 mt-3 d-flex justify-content-between"
                controlId="formBasicCheckbox"
              >
                <style>
                  {`
                    .custom-checkbox input[type="checkbox"] {
                      border:5px solid blue
                      cursor: pointer;
                    }

                    .form-check-input {
                      border: 2px solid var(--bs-dark-blue);
                      opacity: .5;
                    }
              `}
                </style>
                <Form.Check
                  className="text-dark-blue custom-checkbox"
                  type="checkbox"
                  label="Remember Me"
                />
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setShowPasswordResetModal(true);
                  }}
                  style={{ outline: "unset !important" }}
                  className="text-decoration-none text-primary"
                >
                  Forgot Password?
                </a>
              </Form.Group>
              <div className="text-center mt-3">
                <Button
                  type="submit"
                  variant="primary w-100"
                  size="lg"
                  disabled={isSubmitting}
                >
                  Log In{" "}
                  {isSubmitting && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                </Button>
              </div>
              <div className="login-divider my-5">
                <span>or</span>
              </div>
              <div className="text-center mt-3">
                <Button
                  type="button"
                  onClick={() => signInWithGoogle()}
                  variant="outline-primary w-100"
                  size="lg"
                >
                  Continue with Google <img src={GoogleIcon} />
                </Button>
              </div>
            </Form>
            {twoFAModal && <TwoFactorAuth setTwoFAModal={setTwoFAModal} resendCode={handleSubmit} callback={code => dispatchTwoFactorAuth(code)} />}
          </>
        )}
      </Formik>
      <style>
        {`
                   .modal-content {
    	border-radius: var(--bs-border-radius-xl) !important;
  }
                  `}
      </style>
      <Modal
        show={showPasswordResetModal}
        onHide={() => setShowPasswordResetModal(false)}
        centered
        size="md"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          className="border-0 pb-0"
          onClick={() => setShowPasswordResetModal(false)}
        >
          <Modal.Title>Reset Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              email: "",
              submit: false,
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string()
                .email("Must be a valid email")
                .max(255)
                .required("Email is required"),
            })}
            onSubmit={async (
              values,
              { setErrors, setStatus, setSubmitting }
            ) => {
              try {
                const data = await resetPassword(values.email);
                setSubmitting(false);
                setResetPasswordLinkSent(true);

                setTimeout(() => {
                  setResetPasswordLinkSent(false);
                }, 60000);
              } catch (error) {
                const message = error.message || "Something went wrong";
                setStatus({ success: false });
                setErrors({ submit: message });
                setSubmitting(false);
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
              setErrors,
              setStatus,
              setSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                {errors.submit && (
                  <Alert className="my-3" variant="danger">
                    <div className="alert-message">{errors.submit}</div>
                  </Alert>
                )}
                {!isSubmitting && resetPasswordLinkSent && (
                  <Alert className="my-3" variant="info">
                    <div className="alert-message">
                      Password Reset Link Sent, Check Inbox
                    </div>
                  </Alert>
                )}

                <Form.Group className="mb-3">
                  <Form.Label className="text-light-gray">Email</Form.Label>
                  <Form.Control
                    size="lg"
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={values.email}
                    isInvalid={Boolean(touched.email && errors.email)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                  {!!touched.email && (
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
                <div className="text-center mt-3">
                  <Button
                    type="submit"
                    variant="primary w-100"
                    size="lg"
                    disabled={isSubmitting || resetPasswordLinkSent}
                  >
                    Send Reset Link
                    {isSubmitting && (
                      <Spinner
                        className="ms-1"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SignIn;
